import { RootState } from '_store';

import { HeatmapState } from './heatmapReducers';

// eslint-disable-next-line import/prefer-default-export
export const heatmapSelector = (state: RootState): HeatmapState => state.heatmap;
